var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"100vh"}},[_c('v-progress-circular',{attrs:{"size":80,"color":"primary","indeterminate":"","width":"6"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }